import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import * as Constants from '@emi/shared/constants';
import { ConfigureData, Sku, DateRange } from '@emi/shared/models';
import { addConfigureDataSelection, DataExtractionState, getSelectedConfigureData } from '@emi/shared/state/filters';
import { SkuMetadataState, getSkuMetadataState } from '@emi/shared/state/sku-metadata';
import { selectSkuSearchState, SkuSearchState } from '@emi/shared/state/sku-search';
import { select, Store } from '@ngrx/store';
import { DatePickerSettings } from 'libs/shared/ui/src/lib/date-range/models';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { SkuSearchService as GetSkus } from '@emi/shared/data-access';

@Component({
    selector: 'via-sku-capsule',
    templateUrl: './sku-capsule.component.html',
    styleUrls: ['./sku-capsule.component.scss'],
})
export class SkuCapsuleComponent implements OnInit, OnDestroy {
    public showDateRange = true;
    public showFrequency = true;
    public minDate: Date;
    public maxDate: Date;
    public dateSettings: DatePickerSettings;
    public itemId: number;
    public searchResults: Sku[];
    public selectedSku: Sku;
    public selectedDateRange: DateRange = { startDate: undefined, endDate: undefined };

    private configureData = new ConfigureData();
    private configureDataSubscription: Subscription;
    private skuMetadataSubscription: Subscription;
    private skuSearchSubscription: Subscription;

    constructor(
        private router: Router,
        private _location: Location,
        private skuSearchStore: Store<SkuSearchState>,
        private dataExtractionStore: Store<DataExtractionState>,
        private skuMetadataStore: Store<SkuMetadataState>,
        private getSkusService: GetSkus
    ) {
        this.minDate = moment().utc().subtract(Constants.DatePicker.MAX_ALLOWED_YEARS_AGO, 'years').startOf('year').toDate();

        this.skuMetadataSubscription = this.skuMetadataStore.pipe(select(getSkuMetadataState)).subscribe((skuMetadata) => {
            if (skuMetadata.lastUpdated) {
                this.maxDate = skuMetadata.lastUpdated;
                return;
            }
            this.maxDate = moment().utc().subtract(Constants.DatePicker.DEFAULT_MAX_DATE_DAYS_AGO, 'days').toDate();
        });
    }

    public ngOnInit(): void {
        this.itemId = this.router.parseUrl(this.router.url).queryParams.id;

        this.skuSearchSubscription = this.skuSearchStore.pipe(select(selectSkuSearchState)).subscribe((state) => {
            this.searchResults = state.skuResults;
        });

        this.configureDataSubscription = this.dataExtractionStore.pipe(select(getSelectedConfigureData)).subscribe((x) => {
            this.configureData = x;
            this.selectedDateRange.startDate = this.configureData.startDate;
            this.selectedDateRange.endDate = this.configureData.endDate;

            if (this.selectedDateRange.startDate == undefined || this.selectedDateRange.endDate == undefined) {
                this.selectDefaultDateRange();
            }
        });

        this.dateSettings = new DatePickerSettings(
            new DateRange(this.selectedDateRange.startDate, this.selectedDateRange.endDate),
            new DateRange(this.minDate, this.maxDate)
        );

        this.selectedSku = this.searchResults.find((skuResult) => skuResult.emiItemId == this.itemId) || this.selectedSku;
    }

    private selectDefaultDateRange(): void {
        this.updateDateRange(DateRange.getDefaultDateRange(this.maxDate));
    }

    public updateDateRange(dateRange: DateRange) {
        if (dateRange.startDate && dateRange.endDate) {
            this.selectedDateRange = dateRange;
        }
    }

    public backToResults(): void {
        this._location.back();
        this.getSkusService.updateSearchFilterText(false);
    }

    public ngOnDestroy(): void {
        this.configureDataSubscription.unsubscribe();
        this.skuMetadataSubscription.unsubscribe();
        this.skuSearchSubscription.unsubscribe();
    }
}
